var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container",class:{
    'page-container--indent': _vm.indent,
    'page-container--small': _vm.small,
    'page-container--middle': _vm.middle,
    'page-container--extra': _vm.extra
  },style:({ minHeight: _vm.normalizeSize(_vm.minHeight), maxWidth: _vm.normalizeSize(_vm.custom) })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }